
class getDetailDataToSwiperClass {
  constructor(val) {
    this.content = val
    this.ids = val.myid
    this.state = val.$store.state[val.request_prefix]
  }
  async init() {
    const pageType = this.state.type
    if (pageType !== "detailPage") return
    const detailData = window.localStorage.getItem("detailData")
    if (!detailData) return
  }
  //开始进行组件生成
  updateSwiperContent(completeData) {
    const updateCb = (val, content_name, deep, deepName, ids) => {
      this.content.$changeOptionsEV(val, content_name, deep, deepName, ids, true)
    }
    const swiperContent = this.content.options.content
    if (completeData?.length) {
    updateCb(false, "emptyData", false, null, this.ids)
    swiperContent.forEach((contentItem, index) => {
      const rectIds = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        pageId: this.ids.pageId,
        elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
        path: this.ids.path
      }
      const swiperContent_id = contentItem.swiperContent_id
      let completeDataIndex = completeData[index]
      if (!completeDataIndex) {// 当数据小于轮播页时 其他轮播页渲染最后一条数据的值
        completeDataIndex = completeData[completeData.length - 1]
      }
      if (completeDataIndex) {
        let imageList = {}
        Object.keys(completeDataIndex).forEach(key => {
          if (completeDataIndex[key]?.key === "多图轮播") {
            imageList = completeDataIndex[key]
            return
          }
        })
        const data = JSON.parse(JSON.stringify(completeDataIndex))
        contentItem.elementOptions.forEach(item => {
          let key = Object.keys(data).find(
            it => !isNaN(it) && data[it].component_shape.find(it => it === item.innerElement)
          )
          if (key === undefined && item.innerElement === "imageComponent") {
            key =  Object.keys(data).find(
              it => !isNaN(it) && data[it].key === "多图轮播"
            )
          }
          if (key !== undefined) {
            let val = data[key].value
            if (item.innerElement === "imageComponent" && imageList && imageList.subs) {// 图片渲染多图轮播的subs值
              const length = imageList.subs.length
              const curIndex = index > length - 1 ? length - 1 : index
              val = imageList.subs[curIndex]?.value || imageList.subs[curIndex]
            }
            const content_name = this.handleShapeValueName(data[key].component_shape)
            const ids = {
              ...rectIds,
              swiperContent_id: swiperContent_id,
              elementInSwiperId: item.elementInSwiperId,
            }
            updateCb(val, content_name, false, null, ids)
            if (item.hasOwnProperty("linkUrl") && data[key]?.url?.length) {
              updateCb(data[key].url, "linkUrl", false, null, ids)
            }
            delete data[key]
          } else {
            const ids = {
              ...rectIds,
              swiperContent_id: swiperContent_id,
              elementInSwiperId: item.elementInSwiperId,
            }
            updateCb("", "imgSrc", false, null, ids)
            updateCb("", "content", false, null, ids)
          }
        })
      }
    })
    } else {
      updateCb(true, "emptyData", false, null, this.ids)
      console.log("接口数据为空")
    }
  }
  handleShapeValueName(shapeName) {
    if (shapeName.find(it => it === "imageComponent")) return "imgSrc"
    else if (shapeName.find(it => it === "cxVideo")) return "videoUrl"
    else if (shapeName.find(it => it === "cxAudio")) return "audioUrl"
    else return "content"
  }
}
export default {
  data() {
    return {
      getDetailData: new getDetailDataToSwiperClass(this)
    }
  },
  methods: {
    async getDetailDataPlugin() {
      await this.getDetailData.init()
    }
  }
}
